import { render } from "./ButtonAppsDropdown.vue?vue&type=template&id=9f134434&scoped=true"
import script from "./ButtonAppsDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonAppsDropdown.vue?vue&type=script&lang=js"

import "./ButtonAppsDropdown.vue?vue&type=style&index=0&id=9f134434&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-9f134434"

export default script